import React from "react";
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import { Map } from 'immutable';

import { Row, FormInput, FormGroup, Button, ButtonGroup } from "shards-react";

import Modal from 'react-bootstrap/Modal'
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';

import { efectorlistActions, getCurrentEfectorList, getEfectoresForCurrentEfectorList } from "../../core/efector-lists";
import { specialtiesListActions, getCurrentSpecialtiesLists } from "../../core/specialties-lists";
import { locationsListActions, getCurrentLocationsLists } from "../../core/locations-lists";
import { provincesListActions, getCurrentProvincesLists } from "../../core/provinces-lists";
import LocationItemRow from "../locations/location-item-row";
import SearchBarModal from "./search-bar-modal";

class EfectoresModalSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
      toggled_clear_rows: false,
      especialidadId: 0,
      provinciaId: 0,
      localidadId: 0,
    }

    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleFilters = this.handleFilters.bind(this);

  }

  handleRowClick(data, e){
    this.props.handleAdd(data)
  }

  handleFilters({especialidadId, provinciaId, localidadId}){
    const { user,  loadEfectores } = this.props
    loadEfectores(new Map({
      sessionId: user.sessionId,
      especialidadId,
      provinciaId,
      localidadId
    }))
  }

  handleCleanFilters() {
    const { user,  loadEfectores } = this.props

    loadEfectores(new Map({
      sessionId: user.sessionId,
      especialidadId: 0,
      provinciaId: 0,
      localidadI: 0,
    }))

  }

  render() {
    const { efectores, specialties, locations, current_locations,provinces, title, last_efector, show} = this.props

    if (!efectores)
    return null;

    const specialties_options = specialties ? specialties.items.map( (item, key) => <option key={key} value={item.id}>{item.descripcion}</option>) : null
    const locations_options = current_locations ? current_locations.items.map( (item, key) => <option key={key} value={item.id}>{item.nombre}</option>) : null
    const provinces_options = provinces ? provinces.items.map( (item, key) => <option key={key} value={item.id}>{item.nombre}</option>) : null

    const columns = [
      {
        text: 'Nombre y Apellido',
        dataField: 'nombre',
        formatter: (cell, row) => (
          <span>
            { `${row.nombre} ${row.apellido}` }
          </span>
        ),
        filterValue: (cell, row) => (`${row.nombre} ${row.apellido}`)
      },
      {
        text: 'Especialidad',
        dataField: 'especialidad',
        sort:true,
        formatExtraData: specialties,
        formatter: (cell, row) => {
          let text = ""
          if (specialties){
            const specialtie = specialties.items.find(  specialtie => specialtie.id === row.especialidadId )
            if ( specialtie )
              text = specialtie.descripcion
          }
          return (
              <span>
                { `${text}` }
              </span>
            )
        },
        filterValue: (cell, row) => {
          let text = ""
          if (specialties){
            const specialtie = specialties.items.find(  specialtie => specialtie.id === row.especialidadId )
            if ( specialtie )
              text = specialtie.descripcion
          }
          return `${text}`
        }
      },
      {
        text: 'Localidad',
        dataField: 'localidad',
        formatter: (cell, row) => <LocationItemRow locationId={row.localidadId } />,
        sort:true,
        formatExtraData: locations,
        filterValue: (cell, row) => {
          let text = ""
          if ( locations ) {
            const location = locations.find(  location => location.id === row.localidadId )
            if ( location )
              text = `${location.nombre} - ${location.provincia.nombre}`
          }
          return `${text}`
        }
      },
      {
        text: '',
        dataField: 'id',
        formatExtraData: last_efector,
        formatter: (cell, row) => (last_efector === row.id) ? null :
        <div className="btn-group-sm btn-group">
          <button className="btn text-secondary"> <i className="fa fa-plus"></i></button>
        </div>,
        headerStyle: () => {
          return { width: "5%" };
        },
        headerAlign: 'center',
        style: {padding: '6px 0'},
        events: {
          onClick: (e, column, columnIndex, row, rowIndex) => {
            e.preventDefault();
            if ( last_efector === row.id )
              return false;

            this.handleRowClick(row,e)
            return false;
          }
        }
      }
    ]

    return (
      <Modal
        dialogClassName="modal-lg"
        show={show}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{ zIndex: 2500 }}
        onHide={() => this.props.handleClose() }
      >
      <Modal.Header closeButton>
        <h5 className="m-0">
          <i className="far fa-user mr-2"></i> { title }
       </h5>
     </Modal.Header>
     <Modal.Body>
      <ToolkitProvider keyField="id" data={ efectores.toJS()  } columns={ columns } search >
       {
         props => (
           <div>
            <SearchBarModal  { ...props.searchProps } handleFilters={this.handleFilters}  />
            <BootstrapTable  { ...props.baseProps }
             bordered={ false }
             headerClasses="rdt_TableHead"
             pagination={ paginationFactory({
               hideSizePerPage:true,
               hidePageListOnlyOnePage:true
             }) }
          />
          </div>
          )}
        </ToolkitProvider>
        </Modal.Body>
      </Modal>
    );
  }
}

EfectoresModalSearch.propTypes = {
  /**
   * The component's title.
   */
  title: PropTypes.string,

};

EfectoresModalSearch.defaultProps = {
  title: "Agregar Nuevo Efector",
  efectores: null
};

//export default EfectoresModalSearch;

//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {
  return {
    user: state.session.user,
    authenticated: state.session.authenticated,
    efectorlist: getCurrentEfectorList(state, props),
    efectores: getEfectoresForCurrentEfectorList(state, props),
    specialties: getCurrentSpecialtiesLists(state, props),
    provinces: getCurrentProvincesLists(state, props),
    current_locations: getCurrentLocationsLists(state, props),
    locations: state.locations,
  };
};

const mapDispatchToProps = {
  loadEfectores: efectorlistActions.loadEfectores,
  loadLocations : locationsListActions.loadLocations,
  loadSpecialties : specialtiesListActions.loadSpecialties,
  loadProvinces : provincesListActions.loadProvinces,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EfectoresModalSearch);
